import React from 'react';
import { Layout } from '../../components/Layout';
import { Wand2 } from 'lucide-react';

export function AIGenerationPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Wand2 className="h-8 w-8 text-purple-400" />
          <h1 className="text-3xl font-bold text-white">AI Pattern Generation</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Writing Effective Prompts</h2>
              <p>
                The key to getting the best results from the AI generator is writing clear, descriptive prompts. 
                Here are some tips for writing effective prompts:
              </p>
              <ul>
                <li>Be specific about layout structure</li>
                <li>Include design preferences (colors, spacing, etc.)</li>
                <li>Specify any interactive elements</li>
                <li>Mention responsive design requirements</li>
              </ul>
            </section>

            <section>
              <h2>Example Prompts</h2>
              <div className="bg-gray-800/50 rounded-lg p-4 my-4">
                <p className="text-gray-300">
                  "Create a two-column hero section with an image on the left and text content on the right. 
                  Use a gradient background from blue to purple, and include a call-to-action button."
                </p>
              </div>
            </section>

            <section>
              <h2>Customizing AI Output</h2>
              <p>
                After generating a pattern, you can customize it using the visual editor:
              </p>
              <ul>
                <li>Adjust colors and typography</li>
                <li>Modify spacing and alignment</li>
                <li>Add or remove blocks</li>
                <li>Update content and media</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}